import React from 'react';
import {
  Create,
  DeleteWithConfirmButton,
  DisabledInput,
  Edit,
  EditButton,
  List,
  ReferenceField,
  ReferenceInput,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  Toolbar
} from 'react-admin';

import { defaultListProps } from '~constants/config';
import CustomDatagrid from '~components/CustomDatagrid';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

// Which chart category a Subtema counts under in one Fuente's Home charts.
// A Subtema with no row for a Fuente shows under its own name.

// List records translate `name` to the browser's language (`nameEs` is the Spanish one); detail
// records only carry the Spanish `name`. The backoffice is in Spanish.
const spanishName = record => record.nameEs || record.name;

function SubtemaCategoriaToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

function SubtemaCategoriaForm({ children, ...props }) {
  return (
    <SimpleForm {...props} toolbar={<SubtemaCategoriaToolbar />}>
      {children}
      <FieldGroup label="fieldGroups.subtemaCategoria">
        <ReferenceInput source="source" reference="sources" validate={isRequired}>
          <SelectInput optionText={spanishName} />
        </ReferenceInput>
        <ReferenceInput source="subtheme" reference="subthemes" validate={isRequired} perPage={100}
          sort={{ field: 'nombre', order: 'ASC' }}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput source="category" reference="chart-categories" validate={isRequired}>
          <SelectInput optionText={spanishName} />
        </ReferenceInput>
      </FieldGroup>
    </SimpleForm>
  );
}

export function SubtemaCategoriaList(props) {
  return (
    <List {...defaultListProps} {...props}>
      <CustomDatagrid rowClick="edit">
        <ReferenceField source="source" reference="sources" linkType={false} sortBy="fuente__orden">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="subtheme" reference="subthemes" linkType={false} sortBy="subtema__nombre">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="category" reference="chart-categories" linkType={false} sortBy="categoria__nombre">
          <TextField source="name" />
        </ReferenceField>
        <DeleteWithConfirmButton label="" />
        <EditButton label="" />
      </CustomDatagrid>
    </List>
  );
}

export function SubtemaCategoriaCreate(props) {
  return (
    <Create {...props}>
      <SubtemaCategoriaForm redirect="list" />
    </Create>
  );
}

export function SubtemaCategoriaEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <SubtemaCategoriaForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </SubtemaCategoriaForm>
    </Edit>
  );
}
